import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-393884b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "About", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This game is based on the popular Heardle game, but instead of a track a day, you get 10 tracks that are from the top 10 soundtracks in the 2022 Mario Awards XVI, celebrating the anniversary of the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.mariowiki.com/",
    target: "_blank"
  }, "Super Mario Wiki"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("If you have (technical) issues with the game, contact Lakituthequick on the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.mariowiki.com/User:Lakituthequick",
    target: "_blank"
  }, "wiki"),
  /*#__PURE__*/_createTextVNode(" or its "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.marioboards.com/members/3955/",
    target: "_blank"
  }, "forums"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("This version of Heardle is powered by <a href=\"https://vuejs.org/\" target=\"_blank\" data-v-393884b5>Vue.js</a>, <a href=\"https://www.typescriptlang.org/\" target=\"_blank\" data-v-393884b5>TypeScript</a>, <a href=\"https://tarekraafat.github.io/autoComplete.js/\" target=\"_blank\" data-v-393884b5>autoComplete.js</a>, <a href=\"https://fontawesome.com/\" target=\"_blank\" data-v-393884b5>Font Awesome</a>, <a href=\"https://fonts.google.com/specimen/Play\" target=\"_blank\" data-v-393884b5>Google Fonts</a>, and copious amounts of coffee. ", 11)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, [
      _hoisted_4,
      _createVNode(_component_font_awesome_icon, { icon: ['far','coffee-pot'] })
    ])
  ], 64))
}